<template>
  <div class="main-wrapper">
    <div class="login-page" style="background-color: #E4E7EB">
      <div class="login-body container">
        <div class="loginbox" style="padding-bottom: 0px">
          <div class="login-right-wrap">
            <div class="login-header text-center">
              <h5 class="text-muted">Select context to continue...</h5>
              <div class="mt-4">
                <div v-if="success === true && message" class="alert alert-success" role="alert">
                  <strong>Success!</strong> {{ message }}
                </div>
                <div v-if="success === false && message" class="alert alert-danger" role="alert">
                  {{ message }}
                </div>
              </div>
            </div>
            <form class="vld-parent" ref="formContainer">
              <div class="form-group">
                <multiselect
                  @input="setSelectedContext"
                  @remove="handleRemove"
                  v-model="selected"
                  :options="contexts"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :show-labels="false"
                  placeholder="Select customer context"
                  label="displayName"
                  track-by="contextId"
                  class="custom-multiselect"
                >
                  <template slot="option" slot-scope="props">
                    <div class="option-container">
                      <div class="option-title">{{ props.option.displayName }}</div>
                      <div class="option-details">
                        <span v-if="props.option.description" class="status-badge">
                          {{ formatContactType(props.option.description) }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <span>{{ props.option.displayName }}</span>
                  </template>
                </multiselect>
                <select
                  hidden
                  class="form-control"
                  v-model="selectedContextId"
                  :disabled="!contexts || !contexts.length"
                  :required="true">
                  <option disabled>Select customer context</option>
                  <option
                    v-for="context in contexts" :key="context.contextId"
                    :value="context.contextId"
                    :name="context.contextId"
                    :selected="context.contextId === selectedContextId"
                  >
                    {{ context.displayName }}
                  </option>
                </select>
              </div>
              <div class="text-center mb-5">
                <button
                  class="btn btn-primary btn-block account-btn"
                  type="button"
                  @click="toDashboard"
                  :disabled="loading || (!contexts || !contexts.length)"
                  ref="saveButtonContainer"
                >
                  <span v-if="!loading">Continue</span>
                  <span v-else>
                    <i class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></i>
                  </span>
                </button>
                <div class="text-center dont-have mt-3">
                  <i class="fas fa-arrow-left" style="color: #333"></i>
                  <a @click="toLogin" href="javascript:void(0);"> Go back to login</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import jwtDecode from "jwt-decode";
import {allowedModules} from "../../utils/modules";
import Multiselect from 'vue-multiselect'

export default {
  name: "select-business",
  components: {Multiselect},
  data() {
    return {
      success: null,
      message: "",
      contexts: [],
      selected: null,
      selectedContextId: null,
      userId: undefined,
      loading: false,
      fullPage: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    resetMessage() {
      this.message = ""
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  methods: {
    async toDashboard() {
      this.loading = true;
      try {
        if (!this.selected || !this.selectedContextId) {
          this.success = false;
          this.message = "Please select a customer context";
          return;
        }

        const modules = allowedModules.filter(module => module.domains.some(value => value === location.host));
        if (!modules.length) {
          this.success = false;
          this.message = "Not authorised, domain not allowed";
          return;
        }
        this.$i18n.locale = modules[0].name;

        const profile = allowedModules.filter(module => module.name === this.$i18n.locale)[0];

        // Store the selected context information
        localStorage.setItem('selectedContext', JSON.stringify(this.selected));
        localStorage.setItem('selectedContextId', this.selectedContextId);
        localStorage.setItem('contextId', this.selectedContextId);
        localStorage.setItem('actorId', this.selected.actorId);
        localStorage.setItem('mid', this.selectedContextId); // Use contextId as merchant ID
        localStorage.setItem('displayName', this.selected.displayName);
        localStorage.setItem('contactType', this.selected.description || '');
        localStorage.setItem("homeUrl", profile.dashboardUrl);

        // Navigate to dashboard
        await this.$router.push(profile.dashboardUrl);
      } catch (e) {
        console.error('Error navigating to dashboard:', e);
        this.success = false;
        this.message = "An error occurred while navigating to dashboard";
      } finally {
        this.loading = false;
      }
    },
    toLogin() {
      this.$store.dispatch('auth/logout')
      this.$router.push('/login');
    },
    loadCustomerContexts() {
      this.loading = true;
      
      const userToken = localStorage.getItem('user');
      if (!userToken) {
        this.$router.push('/login');
        return;
      }
      
      let user = JSON.parse(userToken);
      
      // Get contexts from login response stored in localStorage
      if (user.availableContexts) {
        // Filter for CUSTOMER_CONTACT contexts
        this.contexts = user.availableContexts.filter(
          context => context.actorType === 'CUSTOMER_CONTACT'
        );
        
        if (!this.contexts || !this.contexts.length) {
          this.success = false;
          this.message = "No customer contexts found for your account.";
          this.loading = false;
          return;
        }
        
        // Auto-select first context
        this.selected = this.contexts[0];
        this.selectedContextId = this.contexts[0].contextId;
      } else {
        this.success = false;
        this.message = "No contexts available.";
      }
      
      this.loading = false;
    },
    fireNotification(icon, title, message) {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
        footer: '<a href="">Need help?</a>'
      })
    },
    handleRemove(selectedOption) {
      this.selected = selectedOption;
    },
    setSelectedContext(selectedContext) {
      this.selectedContextId = selectedContext.contextId;
      this.selected = selectedContext;
      // Clear error message when selecting a new context
      this.success = null;
      this.message = "";
    },
    formatContactType(description) {
      if (!description) return '';
      // Convert "Role: EMERGENCY_CONTACT" to "Emergency Contact"
      const match = description.match(/Role:\s*(.+)/);
      if (match) {
        return match[1].replace(/_/g, ' ').toLowerCase()
          .replace(/\b\w/g, l => l.toUpperCase());
      }
      return description;
    },
    getStatusClass(status) {
      if (!status) return '';
      const statusMap = {
        'ACTIVE': 'status-active',
        'DEACTIVATED': 'status-deactivated',
        'PENDING': 'status-pending',
        'SUSPENDED': 'status-suspended'
      };
      return statusMap[status] || 'status-default';
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    }
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push('/login');
      return;
    }

    let user = JSON.parse(localStorage.getItem('user'));
    let decoded = jwtDecode(user.token);
    this.userId = decoded.sub;

    this.loadCustomerContexts();
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.1em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.option-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 4px 0;
}

.option-title {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 6px;
  font-size: 15px;
  line-height: 1.4;
}

.option-details {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #6c757d;
}

.date-created {
  color: #6c757d;
  font-weight: 500;
  font-size: 12px;
}

.separator {
  color: #dee2e6;
  font-weight: bold;
}

.status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 14px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  white-space: nowrap;
}

.status-active {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.status-deactivated {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.status-suspended {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.status-default {
  background-color: #e9ecef;
  color: #495057;
  border: 1px solid #ced4da;
}

/* Enhance multiselect styling */
.custom-multiselect >>> .multiselect__tags {
  border: 2px solid #dee2e6;
  border-radius: 8px;
  padding: 12px 40px 12px 12px;
  min-height: 50px;
  transition: all 0.3s ease;
}

.custom-multiselect >>> .multiselect__tags:hover {
  border-color: #adb5bd;
}

.custom-multiselect >>> .multiselect__tags:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-multiselect >>> .multiselect__single {
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
  margin-bottom: 0;
  padding-top: 2px;
}

.custom-multiselect >>> .multiselect__placeholder {
  color: #adb5bd;
  font-size: 15px;
  padding-top: 2px;
  margin-bottom: 0;
}

.custom-multiselect >>> .multiselect__select {
  height: 50px;
  transition: transform 0.3s ease;
}

.custom-multiselect >>> .multiselect__select:before {
  border-color: #667eea transparent transparent;
  border-width: 6px 6px 0;
  top: 55%;
}

.custom-multiselect >>> .multiselect__content-wrapper {
  border: 2px solid #dee2e6;
  border-radius: 8px;
  margin-top: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
}

.custom-multiselect >>> .multiselect__option {
  padding: 14px 16px;
  min-height: auto;
  line-height: 1.4;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f8f9fa;
}

.custom-multiselect >>> .multiselect__option:last-child {
  border-bottom: none;
}

.custom-multiselect >>> .multiselect__option--highlight {
  background: #f8f9fa;
  color: #2c3e50;
}

.custom-multiselect >>> .multiselect__option--highlight:after {
  display: none;
}

.custom-multiselect >>> .multiselect__option--selected {
  background: #ffffff;
  color: #2c3e50;
  font-weight: normal;
}

.custom-multiselect >>> .multiselect__option--selected:after {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/auth/SelectBusiness.vue